import { getFromLocalStorage, LOGGED_IN_USER } from "./localStorageutils";

const roles = {
  reporting_manager: {
    REQUEST_TABS: true,
    RAISE_REQUEST: true,
    EDIT_REQUEST: true,
    ADD_COURSE: false,
    REJECT_RM_DETAILS: false,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: true,
    APPROVE_STAGES: false,
    EDIT_COURSE_DETAILS: false,
    COURSE_MANAGEMENT: {
      ROOT: true,
      COURSE_REQUEST: true,
      COURSE_LIST: true,
      COURSE_CARD_ITEM: true,
    },
    CREATE_COURSE_STAGES: false,
    ADD_COMMENT: false,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: false,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: false,
    CREATE_QUESTION_BANK: false,
    VIEW_TIME_LINE_COURSE: true,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: false,
    MASTER_DATA: {
      ROOT: false,
      QUESTION_BANK: false,
      POLICY: false,
      CURRICULUM: false,
      SGA: false,
      DOMAIN: false,
      COMPETENCY: false,
      LEARNING_OUTCOME: false,
      INDUSTRY: false,
      JOB_ROLE: false,
      GRADE: false,
      CLASSROOM: false,
      LOCATION: false,
      SUB_LOCATION: false,
      REGION: false,
      ASSET_MANAGEMENT: false,
      LEARNING_PLANS: false,
    },
    USER_MANAGEMENT: {
      ROOT: true,
      TM_LEARNING_PLAN: true,
      SUSPENDED_USERS: false,
      TRAINER_EXTERNAL_USER: false,
      MAP_ROLE_TO_USER: false,
      ADD_CURRICULUM: false,
      MAP_SGA: false,
      MAP_ASSESSMENT: false,
      ASSIGN_YEAR_TO_COURSE: true,
      ASSIGN_ILP: true,
      MODIFY_YEAR_TO_COURSE: true,
      APPROVE_MODIFIED_YEAR: false,
    },
    MY_ASSESSMENT: false,
    ASSESSMENT_MANAGEMENT: {
      ROOT: true,
      ASSESSMENT_CATALOG: false,
      ASSESSMENT_REVIEW: true,
    },
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    REVIEW_SELF_ASSESSMENT: true,
    UPLOAD_SKILL_DOC: false,
    APPROVE_SKILL_DOC: true,
    RM_ASSESSMENT_CATLOG: true,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: false,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: false,
      MANAGE_SURVEYS: false,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: false,
    LOAD_FACTOR_ACTION: false,
    UPSERT_COURSE_SCHEDULE: false,
    SCHEDULED_COURSE_LIST: false,
    ASSIGN_TRAINERS: false,
    ADD_NOMINEES: false,
    UPSERT_ASSET_TO_SCHEDULE: false,
    APPROVE_SCHEDULE: false,
    SCHEDULE_COURSE_TABS: false,
    RATE_TRAINEE: false,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: false,
    MARK_LEARNER_ATTENDANCE: false,
    NOMINATION_REQUEST: true,
    COURSE_CATALOG: true,
    MY_DEVELOPMENT_PLAN: {
      ROOT: false,
      MY_LEARNING_PLAN: false,
      SCHEDULED_COURSES: false,
    },
    UNMAP_CURRICULUM: false,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: false,
    APPROVE_SGA_EXTENSION: true,
    CALL_MASTER_API: true,
    SHOW_REPORTS: true,
    MY_TEAM: true,
    TA_ASSESSMENT_DETAILS: true,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: true,
      PENDING_SKILL_SUBMISSIONS: true,
      ASSESSMENT_REVIEW: true,
      COURSE_SESSION_ASSIGNMENT: false,
      FEEDBACK: false,
      TRAINING_SCHEDULES: false,
      TRAINING_IMPRESSIONS: true,
    },
    NOMINATION_STATUS: false,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
  training_manager: {
    REQUEST_TABS: true,
    RAISE_REQUEST: true,
    EDIT_REQUEST: true,
    ADD_COURSE: true,
    REJECT_RM_DETAILS: true,
    TRAINER_BOND_DETAILS: true,
    VIEW_RM_REQUEST: true,
    APPROVE_STAGES: true,
    EDIT_COURSE_DETAILS: true,
    COURSE_MANAGEMENT: {
      ROOT: true,
      COURSE_REQUEST: true,
      COURSE_LIST: true,
      COURSE_CARD_ITEM: true,
    },
    CREATE_COURSE_STAGES: false,
    ADD_COMMENT: true,
    PUBLISH_CONTENT: true,
    CREATE_ASSESSMENT: false,
    CREATE_QUESTION_BANK: true,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: true,
    VIEW_TIME_LINE_COURSE: true,
    WBT_PUBLISH: true,
    CREATE_ASSESSMENT_CATLOG: true,
    MASTER_DATA: {
      ROOT: true,
      QUESTION_BANK: true,
      POLICY: true,
      CURRICULUM: true,
      SGA: true,
      DOMAIN: true,
      COMPETENCY: true,
      LEARNING_OUTCOME: true,
      INDUSTRY: true,
      JOB_ROLE: true,
      GRADE: true,
      CLASSROOM: true,
      LOCATION: true,
      SUB_LOCATION: true,
      REGION: true,
      ASSET_MANAGEMENT: true,
      LEARNING_PLANS: true,
    },
    USER_MANAGEMENT: {
      ROOT: true,
      TM_LEARNING_PLAN: true,
      SUSPENDED_USERS: true,
      TRAINER_EXTERNAL_USER: false,
      MAP_ROLE_TO_USER: true,
      ADD_CURRICULUM: true,
      MAP_SGA: true,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: true,
      MODIFY_YEAR_TO_COURSE: true,
      APPROVE_MODIFIED_YEAR: true,
      MAP_ASSESSMENT: true,
    },

    MY_ASSESSMENT: false,
    ASSESSMENT_MANAGEMENT: {
      ROOT: true,
      ASSESSMENT_CATALOG: true,
      ASSESSMENT_REVIEW: true,
    },
    MODIFY_PUBLISHED_ASSESSMENT: true,
    REVOKE_EDITOR_ACCESS: true,
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: false,
    APPROVE_SKILL_DOC: false,
    RM_ASSESSMENT_CATLOG: false,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: true,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: true,
      MANAGE_SURVEYS: true,
      PENDING_FOR_APPROVAL: true,
      SHOW_PENDING_FOR_APPROVAL: true,
    },
    LOAD_FACTOR: true,
    LOAD_FACTOR_ACTION: true,
    UPSERT_COURSE_SCHEDULE: true,
    SCHEDULED_COURSE_LIST: true,
    ASSIGN_TRAINERS: true,
    ADD_NOMINEES: true,
    UPSERT_ASSET_TO_SCHEDULE: false,
    APPROVE_SCHEDULE: false,
    SCHEDULE_COURSE_TABS: true,
    RATE_TRAINEE: false,
    GLOBAL_SETTINGS: true,
    MARK_TRAINER_ATTENDANCE: true,
    MARK_LEARNER_ATTENDANCE: false,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: true,
    MY_DEVELOPMENT_PLAN: {
      ROOT: false,
      MY_LEARNING_PLAN: false,
      SCHEDULED_COURSES: false,
    },
    UNMAP_CURRICULUM: true,
    UNMAP_SGA: true,
    RAISE_SGA_EXTENSION: false,
    APPROVE_SGA_EXTENSION: true,
    CALL_MASTER_API: true,
    SHOW_REPORTS: true,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: true,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: true,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: false,
      ASSESSMENT_REVIEW: true,
      COURSE_SESSION_ASSIGNMENT: false,
      FEEDBACK: false,
      TRAINING_SCHEDULES: false,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: true,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
  training_admin: {
    REQUEST_TABS: false,
    RAISE_REQUEST: false,
    EDIT_REQUEST: false,
    ADD_COURSE: false,
    REJECT_RM_DETAILS: false,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: false,
    APPROVE_STAGES: false,
    EDIT_COURSE_DETAILS: false,
    COURSE_MANAGEMENT: {
      ROOT: true,
      COURSE_REQUEST: false,
      COURSE_LIST: true,
      COURSE_CARD_ITEM: true,
    },
    CREATE_COURSE_STAGES: false,
    ADD_COMMENT: true,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: false,
    CREATE_QUESTION_BANK: false,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: true,
    VIEW_TIME_LINE_COURSE: true,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: false,
    MASTER_DATA: {
      ROOT: true,
      QUESTION_BANK: false,
      POLICY: true,
      CURRICULUM: true,
      SGA: true,
      DOMAIN: true,
      COMPETENCY: true,
      LEARNING_OUTCOME: true,
      INDUSTRY: true,
      JOB_ROLE: true,
      GRADE: true,
      CLASSROOM: true,
      LOCATION: true,
      SUB_LOCATION: true,
      REGION: true,
      ASSET_MANAGEMENT: true,
      LEARNING_PLANS: true,
    },
    USER_MANAGEMENT: {
      ROOT: true,
      TM_LEARNING_PLAN: true,
      SUSPENDED_USERS: true,
      TRAINER_EXTERNAL_USER: false,
      MAP_ROLE_TO_USER: true,
      ADD_CURRICULUM: true,
      MAP_SGA: false,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: true,
      MODIFY_YEAR_TO_COURSE: false,
      APPROVE_MODIFIED_YEAR: true,
      MAP_ASSESSMENT: true,
    },

    MY_ASSESSMENT: false,
    ASSESSMENT_MANAGEMENT: {
      ROOT: false,
      ASSESSMENT_CATALOG: false,
      ASSESSMENT_REVIEW: false,
    },
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: false,
    APPROVE_SKILL_DOC: false,
    RM_ASSESSMENT_CATLOG: false,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: true,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: true,
      MANAGE_SURVEYS: true,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: true,
    LOAD_FACTOR_ACTION: true,
    UPSERT_COURSE_SCHEDULE: true,
    SCHEDULED_COURSE_LIST: true,
    ASSIGN_TRAINERS: true,
    ADD_NOMINEES: true,
    UPSERT_ASSET_TO_SCHEDULE: false,
    APPROVE_SCHEDULE: false,
    SCHEDULE_COURSE_TABS: true,
    RATE_TRAINEE: false,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: true,
    MARK_LEARNER_ATTENDANCE: false,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: true,
    MY_DEVELOPMENT_PLAN: {
      ROOT: false,
      MY_LEARNING_PLAN: false,
      SCHEDULED_COURSES: false,
    },
    UNMAP_CURRICULUM: true,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: false,
    APPROVE_SGA_EXTENSION: true,
    CALL_MASTER_API: true,
    SHOW_REPORTS: true,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: false,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: false,
      ASSESSMENT_REVIEW: false,
      COURSE_SESSION_ASSIGNMENT: false,
      FEEDBACK: false,
      TRAINING_SCHEDULES: false,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: true,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
  hr_admin: {
    REQUEST_TABS: true,
    RAISE_REQUEST: true,
    EDIT_REQUEST: true,
    ADD_COURSE: true,
    REJECT_RM_DETAILS: true,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: true,
    APPROVE_STAGES: false,
    EDIT_COURSE_DETAILS: true,
    COURSE_MANAGEMENT: {
      ROOT: true,
      COURSE_REQUEST: true,
      COURSE_LIST: true,
      COURSE_CARD_ITEM: true,
    },
    CREATE_COURSE_STAGES: false,
    ADD_COMMENT: true,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: false,
    CREATE_QUESTION_BANK: true,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: false,
    VIEW_TIME_LINE_COURSE: true,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: false,
    MASTER_DATA: {
      ROOT: true,
      QUESTION_BANK: true,
      POLICY: false,
      CURRICULUM: false,
      SGA: true,
      DOMAIN: true,
      COMPETENCY: true,
      LEARNING_OUTCOME: true,
      INDUSTRY: true,
      JOB_ROLE: true,
      GRADE: true,
      CLASSROOM: true,
      LOCATION: true,
      SUB_LOCATION: true,
      REGION: true,
      ASSET_MANAGEMENT: true,
      LEARNING_PLANS: true,
    },
    USER_MANAGEMENT: {
      ROOT: false,
      TM_LEARNING_PLAN: false,
      SUSPENDED_USERS: false,
      TRAINER_EXTERNAL_USER: false,
      MAP_ROLE_TO_USER: false,
      ADD_CURRICULUM: true,
      MAP_SGA: true,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: true,
      MODIFY_YEAR_TO_COURSE: true,
      APPROVE_MODIFIED_YEAR: true,
      MAP_ASSESSMENT: true,
    },

    MY_ASSESSMENT: false,
    ASSESSMENT_MANAGEMENT: {
      ROOT: false,
      ASSESSMENT_CATALOG: false,
      ASSESSMENT_REVIEW: false,
    },
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: false,
    APPROVE_SKILL_DOC: false,
    RM_ASSESSMENT_CATLOG: false,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: true,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: true,
      MANAGE_SURVEYS: true,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: false,
    LOAD_FACTOR_ACTION: false,
    UPSERT_COURSE_SCHEDULE: true,
    SCHEDULED_COURSE_LIST: true,
    ASSIGN_TRAINERS: true,
    ADD_NOMINEES: true,
    UPSERT_ASSET_TO_SCHEDULE: false,
    APPROVE_SCHEDULE: false,
    SCHEDULE_COURSE_TABS: true,
    RATE_TRAINEE: false,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: false,
    MARK_LEARNER_ATTENDANCE: false,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: true,
    MY_DEVELOPMENT_PLAN: {
      ROOT: false,
      MY_LEARNING_PLAN: false,
      SCHEDULED_COURSES: false,
    },
    UNMAP_CURRICULUM: true,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: false,
    APPROVE_SGA_EXTENSION: false,
    CALL_MASTER_API: true,
    SHOW_REPORTS: true,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: true,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: false,
      ASSESSMENT_REVIEW: false,
      COURSE_SESSION_ASSIGNMENT: false,
      FEEDBACK: false,
      TRAINING_SCHEDULES: false,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: true,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
  sme: {
    REQUEST_TABS: false,
    RAISE_REQUEST: false,
    EDIT_REQUEST: false,
    ADD_COURSE: false,
    REJECT_RM_DETAILS: false,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: false,
    APPROVE_STAGES: true,
    EDIT_COURSE_DETAILS: false,
    COURSE_MANAGEMENT: {
      ROOT: true,
      COURSE_REQUEST: false,
      COURSE_LIST: true,
      COURSE_CARD_ITEM: true,
    },
    CREATE_COURSE_STAGES: false,
    ADD_COMMENT: true,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: false,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: false,
    CREATE_QUESTION_BANK: false,
    VIEW_TIME_LINE_COURSE: true,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: false,
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    USER_MANAGEMENT: {
      ROOT: false,
      TM_LEARNING_PLAN: false,
      SUSPENDED_USERS: false,
      TRAINER_EXTERNAL_USER: false,
      ADD_CURRICULUM: false,
      MAP_ROLE_TO_USER: false,
      MAP_COURSE: false,
      MAP_SGA: false,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: false,
      MODIFY_YEAR_TO_COURSE: false,
      APPROVE_MODIFIED_YEAR: false,
      MAP_ASSESSMENT: false,
    },
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: false,
    APPROVE_SKILL_DOC: false,
    ASSESSMENT_MANAGEMENT: {
      ROOT: false,
      ASSESSMENT_CATALOG: false,
      ASSESSMENT_REVIEW: false,
    },
    RM_ASSESSMENT_CATLOG: false,
    MASTER_DATA: {
      ROOT: false,
      QUESTION_BANK: false,
      POLICY: false,
      CURRICULUM: false,
      SGA: false,
      DOMAIN: false,
      COMPETENCY: false,
      LEARNING_OUTCOME: false,
      INDUSTRY: false,
      JOB_ROLE: false,
      GRADE: false,
      CLASSROOM: false,
      LOCATION: false,
      SUB_LOCATION: false,
      REGION: false,
      ASSET_MANAGEMENT: false,
      LEARNING_PLANS: false,
    },
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: false,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: false,
      MANAGE_SURVEYS: false,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: false,
    LOAD_FACTOR_ACTION: false,
    UPSERT_COURSE_SCHEDULE: false,
    SCHEDULED_COURSE_LIST: false,
    ASSIGN_TRAINERS: false,
    ADD_NOMINEES: false,
    UPSERT_ASSET_TO_SCHEDULE: false,
    APPROVE_SCHEDULE: false,
    SCHEDULE_COURSE_TABS: false,
    RATE_TRAINEE: false,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: false,
    MARK_LEARNER_ATTENDANCE: false,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: true,
    MY_DEVELOPMENT_PLAN: {
      ROOT: false,
      MY_LEARNING_PLAN: false,
      SCHEDULED_COURSES: false,
    },
    UNMAP_CURRICULUM: false,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: false,
    APPROVE_SGA_EXTENSION: false,
    CALL_MASTER_API: false,
    SHOW_REPORTS: true,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: false,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: false,
      ASSESSMENT_REVIEW: false,
      COURSE_SESSION_ASSIGNMENT: false,
      FEEDBACK: false,
      TRAINING_SCHEDULES: false,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: false,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
  internal_trainer: {
    REQUEST_TABS: true,
    RAISE_REQUEST: true,
    EDIT_REQUEST: true,
    ADD_COURSE: false,
    REJECT_RM_DETAILS: false,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: false,
    APPROVE_STAGES: false,
    EDIT_COURSE_DETAILS: false,
    COURSE_MANAGEMENT: {
      ROOT: true,
      COURSE_REQUEST: true,
      COURSE_LIST: true,
      COURSE_CARD_ITEM: true,
    },
    CREATE_COURSE_STAGES: true,
    ADD_COMMENT: true,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: true,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: false,
    CREATE_QUESTION_BANK: true,
    VIEW_TIME_LINE_COURSE: true,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: true,
    MASTER_DATA: {
      ROOT: true,
      QUESTION_BANK: true,
      POLICY: false,
      CURRICULUM: false,
      SGA: false,
      DOMAIN: true,
      COMPETENCY: true,
      LEARNING_OUTCOME: true,
      INDUSTRY: false,
      JOB_ROLE: false,
      GRADE: false,
      CLASSROOM: false,
      LOCATION: false,
      SUB_LOCATION: false,
      REGION: false,
      ASSET_MANAGEMENT: false,
      LEARNING_PLANS: false,
    },
    USER_MANAGEMENT: {
      ROOT: true,
      TM_LEARNING_PLAN: true,
      SUSPENDED_USERS: false,
      TRAINER_EXTERNAL_USER: true,
      MAP_ROLE_TO_USER: false,
      ADD_CURRICULUM: false,
      MAP_SGA: false,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: false,
      MODIFY_YEAR_TO_COURSE: false,
      APPROVE_MODIFIED_YEAR: false,
      MAP_ASSESSMENT: false,
    },
    MY_ASSESSMENT: false,
    ASSESSMENT_MANAGEMENT: {
      ROOT: true,
      ASSESSMENT_CATALOG: true,
      ASSESSMENT_REVIEW: true,
    },
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: false,
    APPROVE_SKILL_DOC: false,
    RM_ASSESSMENT_CATLOG: false,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: false,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: false,
      MANAGE_SURVEYS: false,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: true,
    LOAD_FACTOR_ACTION: false,
    UPSERT_COURSE_SCHEDULE: false,
    SCHEDULED_COURSE_LIST: true,
    ASSIGN_TRAINERS: false,
    ADD_NOMINEES: false,
    UPSERT_ASSET_TO_SCHEDULE: true,
    APPROVE_SCHEDULE: true,
    SCHEDULE_COURSE_TABS: true,
    RATE_TRAINEE: true,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: false,
    MARK_LEARNER_ATTENDANCE: true,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: true,
    MY_DEVELOPMENT_PLAN: {
      ROOT: false,
      MY_LEARNING_PLAN: false,
      SCHEDULED_COURSES: false,
    },
    UNMAP_CURRICULUM: false,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: false,
    APPROVE_SGA_EXTENSION: false,
    CALL_MASTER_API: true,
    SHOW_REPORTS: true,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: true,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: false,
      ASSESSMENT_REVIEW: true,
      COURSE_SESSION_ASSIGNMENT: true,
      FEEDBACK: false,
      TRAINING_SCHEDULES: false,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: true,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: true,
  },
  external_trainer: {
    REQUEST_TABS: false,
    RAISE_REQUEST: false,
    EDIT_REQUEST: false,
    ADD_COURSE: false,
    REJECT_RM_DETAILS: false,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: false,
    APPROVE_STAGES: false,
    EDIT_COURSE_DETAILS: false,
    COURSE_MANAGEMENT: {
      ROOT: true,
      COURSE_REQUEST: false,
      COURSE_LIST: true,
      COURSE_CARD_ITEM: true,
    },
    CREATE_COURSE_STAGES: true,
    ADD_COMMENT: true,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: true,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: false,
    CREATE_QUESTION_BANK: true,
    VIEW_TIME_LINE_COURSE: true,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: true,
    MASTER_DATA: {
      ROOT: true,
      QUESTION_BANK: true,
      POLICY: false,
      CURRICULUM: false,
      SGA: false,
      DOMAIN: false,
      COMPETENCY: false,
      LEARNING_OUTCOME: false,
      INDUSTRY: false,
      JOB_ROLE: false,
      GRADE: false,
      CLASSROOM: false,
      LOCATION: false,
      SUB_LOCATION: false,
      REGION: false,
      ASSET_MANAGEMENT: false,
      LEARNING_PLANS: false,
    },
    USER_MANAGEMENT: {
      ROOT: false,
      TM_LEARNING_PLAN: false,
      SUSPENDED_USERS: false,
      TRAINER_EXTERNAL_USER: false,
      MAP_ROLE_TO_USER: false,
      ADD_CURRICULUM: false,
      MAP_SGA: false,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: false,
      MODIFY_YEAR_TO_COURSE: false,
      APPROVE_MODIFIED_YEAR: false,
      MAP_ASSESSMENT: false,
    },
    MY_ASSESSMENT: false,
    ASSESSMENT_MANAGEMENT: {
      ROOT: true,
      ASSESSMENT_CATALOG: true,
      ASSESSMENT_REVIEW: true,
    },
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: false,
    APPROVE_SKILL_DOC: false,
    RM_ASSESSMENT_CATLOG: false,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: false,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: false,
      MANAGE_SURVEYS: false,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: false,
    LOAD_FACTOR_ACTION: false,
    UPSERT_COURSE_SCHEDULE: false,
    SCHEDULED_COURSE_LIST: true,
    ASSIGN_TRAINERS: false,
    ADD_NOMINEES: false,
    UPSERT_ASSET_TO_SCHEDULE: true,
    APPROVE_SCHEDULE: true,
    SCHEDULE_COURSE_TABS: true,
    RATE_TRAINEE: true,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: false,
    MARK_LEARNER_ATTENDANCE: true,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: false,
    MY_DEVELOPMENT_PLAN: {
      ROOT: false,
      MY_LEARNING_PLAN: false,
      SCHEDULED_COURSES: false,
    },
    UNMAP_CURRICULUM: false,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: false,
    APPROVE_SGA_EXTENSION: false,
    CALL_MASTER_API: true,
    SHOW_REPORTS: true,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: true,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: false,
      ASSESSMENT_REVIEW: true,
      COURSE_SESSION_ASSIGNMENT: true,
      FEEDBACK: false,
      TRAINING_SCHEDULES: false,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: false,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
  internal_learner: {
    REQUEST_TABS: false,
    RAISE_REQUEST: false,
    EDIT_REQUEST: false,
    ADD_COURSE: false,
    REJECT_RM_DETAILS: false,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: false,
    APPROVE_STAGES: false,
    EDIT_COURSE_DETAILS: false,
    COURSE_MANAGEMENT_SUB_MENU: false,
    COURSE_MANAGEMENT: {
      ROOT: false,
      COURSE_REQUEST: false,
      COURSE_LIST: false,
      COURSE_CARD_ITEM: false,
    },
    CREATE_COURSE_STAGES: false,
    ADD_COMMENT: false,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: false,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: false,
    CREATE_QUESTION_BANK: false,
    VIEW_TIME_LINE_COURSE: false,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: false,
    MASTER_DATA: {
      ROOT: false,
      QUESTION_BANK: false,
      POLICY: false,
      CURRICULUM: false,
      SGA: false,
      DOMAIN: false,
      COMPETENCY: false,
      LEARNING_OUTCOME: false,
      INDUSTRY: false,
      JOB_ROLE: false,
      GRADE: false,
      CLASSROOM: false,
      LOCATION: false,
      SUB_LOCATION: false,
      REGION: false,
      ASSET_MANAGEMENT: false,
      LEARNING_PLANS: false,
    },
    USER_MANAGEMENT: {
      ROOT: false,
      TM_LEARNING_PLAN: false,
      SUSPENDED_USERS: false,
      TRAINER_EXTERNAL_USER: false,
      MAP_ROLE_TO_USER: false,
      ADD_CURRICULUM: false,
      MAP_SGA: false,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: false,
      MODIFY_YEAR_TO_COURSE: false,
      APPROVE_MODIFIED_YEAR: false,
      MAP_ASSESSMENT: false,
    },
    MY_ASSESSMENT: true,
    ASSESSMENT_MANAGEMENT: {
      ROOT: false,
      ASSESSMENT_CATALOG: false,
      ASSESSMENT_REVIEW: false,
    },
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: true,
    APPROVE_SKILL_DOC: false,
    RM_ASSESSMENT_CATLOG: false,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: false,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: false,
      MANAGE_SURVEYS: false,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: false,
    LOAD_FACTOR_ACTION: false,
    UPSERT_COURSE_SCHEDULE: false,
    SCHEDULED_COURSE_LIST: false,
    ASSIGN_TRAINERS: false,
    ADD_NOMINEES: false,
    UPSERT_ASSET_TO_SCHEDULE: false,
    APPROVE_SCHEDULE: false,
    SCHEDULE_COURSE_TABS: false,
    RATE_TRAINEE: false,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: false,
    MARK_LEARNER_ATTENDANCE: false,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: true,
    MY_DEVELOPMENT_PLAN: {
      ROOT: true,
      MY_LEARNING_PLAN: true,
      SCHEDULED_COURSES: true,
    },
    UNMAP_CURRICULUM: false,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: true,
    APPROVE_SGA_EXTENSION: false,
    CALL_MASTER_API: false,
    SHOW_REPORTS: false,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: true,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: true,
      ASSESSMENT_REVIEW: false,
      COURSE_SESSION_ASSIGNMENT: false,
      FEEDBACK: true,
      TRAINING_SCHEDULES: true,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: false,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
  external_learner: {
    REQUEST_TABS: false,
    RAISE_REQUEST: false,
    EDIT_REQUEST: false,
    ADD_COURSE: false,
    REJECT_RM_DETAILS: false,
    TRAINER_BOND_DETAILS: false,
    VIEW_RM_REQUEST: false,
    APPROVE_STAGES: false,
    EDIT_COURSE_DETAILS: false,
    COURSE_MANAGEMENT_SUB_MENU: false,
    COURSE_MANAGEMENT: {
      ROOT: false,
      COURSE_REQUEST: false,
      COURSE_LIST: false,
      COURSE_CARD_ITEM: false,
    },
    CREATE_COURSE_STAGES: false,
    ADD_COMMENT: false,
    PUBLISH_CONTENT: false,
    CREATE_ASSESSMENT: false,
    UN_PUBLISH_COURSE: false,
    CREATE_CURRICULUM: false,
    CREATE_QUESTION_BANK: false,
    VIEW_TIME_LINE_COURSE: false,
    WBT_PUBLISH: false,
    CREATE_ASSESSMENT_CATLOG: false,
    MASTER_DATA: {
      ROOT: false,
      QUESTION_BANK: false,
      POLICY: false,
      CURRICULUM: false,
      SGA: false,
      DOMAIN: false,
      COMPETENCY: false,
      LEARNING_OUTCOME: false,
      INDUSTRY: false,
      JOB_ROLE: false,
      GRADE: false,
      CLASSROOM: false,
      LOCATION: false,
      SUB_LOCATION: false,
      REGION: false,
      ASSET_MANAGEMENT: false,
      LEARNING_PLANS: false,
    },
    USER_MANAGEMENT: {
      ROOT: false,
      TM_LEARNING_PLAN: false,
      SUSPENDED_USERS: false,
      TRAINER_EXTERNAL_USER: false,
      MAP_ROLE_TO_USER: false,
      ADD_CURRICULUM: false,
      MAP_SGA: false,
      ASSIGN_YEAR_TO_COURSE: false,
      ASSIGN_ILP: false,
      MODIFY_YEAR_TO_COURSE: false,
      APPROVE_MODIFIED_YEAR: false,
      MAP_ASSESSMENT: false,
    },
    MY_ASSESSMENT: true,
    ASSESSMENT_MANAGEMENT: {
      ROOT: false,
      ASSESSMENT_CATALOG: false,
      ASSESSMENT_REVIEW: false,
    },
    MODIFY_PUBLISHED_ASSESSMENT: false,
    REVOKE_EDITOR_ACCESS: false,
    REVIEW_SELF_ASSESSMENT: false,
    UPLOAD_SKILL_DOC: true,
    APPROVE_SKILL_DOC: false,
    RM_ASSESSMENT_CATLOG: false,
    MENTORING: {
      ROOT: true,
      MANAGE_MENTORING: false,
      MENTOR: true,
      MENTEE: true,
    },
    SURVEY_MANAGEMENT: {
      ROOT: false,
      MANAGE_SURVEYS: false,
      PENDING_FOR_APPROVAL: false,
      SHOW_PENDING_FOR_APPROVAL: false,
    },
    LOAD_FACTOR: false,
    LOAD_FACTOR_ACTION: false,
    UPSERT_COURSE_SCHEDULE: false,
    SCHEDULED_COURSE_LIST: false,
    ASSIGN_TRAINERS: false,
    ADD_NOMINEES: false,
    UPSERT_ASSET_TO_SCHEDULE: false,
    APPROVE_SCHEDULE: false,
    SCHEDULE_COURSE_TABS: false,
    RATE_TRAINEE: false,
    GLOBAL_SETTINGS: false,
    MARK_TRAINER_ATTENDANCE: false,
    MARK_LEARNER_ATTENDANCE: false,
    NOMINATION_REQUEST: false,
    COURSE_CATALOG: false,
    MY_DEVELOPMENT_PLAN: {
      ROOT: true,
      MY_LEARNING_PLAN: true,
      SCHEDULED_COURSES: true,
    },
    UNMAP_CURRICULUM: false,
    UNMAP_SGA: false,
    RAISE_SGA_EXTENSION: true,
    APPROVE_SGA_EXTENSION: false,
    CALL_MASTER_API: false,
    SHOW_REPORTS: false,
    MY_TEAM: false,
    TA_ASSESSMENT_DETAILS: true,
    ACTION_MENU: {
      EMPLOYEE_ENGAGEMENT: false,
      NOMINATION_REQUEST: false,
      PENDING_SKILL_SUBMISSIONS: true,
      ASSESSMENT_REVIEW: false,
      COURSE_SESSION_ASSIGNMENT: false,
      FEEDBACK: true,
      TRAINING_SCHEDULES: true,
      TRAINING_IMPRESSIONS: false,
    },
    NOMINATION_STATUS: false,
    INSTRUCTOR_ACTIVITY_TIME_TRACKING: false,
  },
};

export const Session = () => {
  return getFromLocalStorage(LOGGED_IN_USER);
};

export const hasPermissionToComponent = (componentPath: string) => {
  const session = Session();

  const keys = componentPath.split(".");

  if (session?.role) {
    let permission = roles[session.role];

    for (const key of keys) {
      if (permission && permission[key] !== undefined) {
        permission = permission[key];
      } else {
        return false;
      }
    }
    return !!permission;
  }

  return false;
};

export const getPermissionObject = (component: string) => {
  const session = Session();
  if (session?.role) {
    const permission = roles[session.role];
    if (permission && permission[component] !== undefined) {
      return permission[component];
    }
  }
};

export const isCurrentUserIsCourseOwner = id => {
  const session = Session();

  if (session?.role && session.id) {
    const hasPermission = hasPermissionToComponent(
      "MODIFY_PUBLISHED_ASSESSMENT"
    );
    if (hasPermission || session.id === id) {
      return true;
    }
  }

  return false;
};

export const currentUserId = () => {
  const session = Session();

  if (session?.id) {
    return session.id;
  }
  return null;
};

export const pathPrevilages = {
  reporting_manager: {
    dashboard: true,
    userManagement: true,
    userDetails: true,
    createRequest: true,
    createCourse: false,
    requestList: true,
    courseList: true,
    requestDetails: true,
    courseDetails: true,
    loDetails: true,
    competencyDetails: true,
    lessonPlanDetails: true,
    additionInfoDetails: true,
    courseAssessmentDetails: true,
    questionBankPreview: true,
    courseMaterialsDetails: true,
    trainerBondDetails: false,
    webinarCompetencyDetails: true,
    addLoDetails: false,
    addCompetencyDetails: false,
    addWebinarDetails: false,
    addLessonPlanDetails: false,
    addAdditionInfoDetails: false,
    addAssessmentDetails: false,
    addMaterialsDetails: false,
    curriculumList: false,
    policyList: false,
    addCurriculumDetails: false,
    questionBankList: false,
    createQuestionBankDetails: false,
    addPolicyDetails: false,
    sgaList: false,
    mapSGADetails: false,
    myLearningPlan: false,
    addAssessmentCatlog: false,
    assessmentCatlogDetails: true,
    scheduleAssessmentCatlog: false,
    scheduledUserDetails: false,
    competencyAssessment: true,
    reviewCompetencyAssessment: true,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: true,
    learnerAssessmetsList: false,
    learnerAssessmetsDetails: false,
    attemptsDetails: false,
    assessmentCatlogList: false,
    domainList: false,
    competencyList: false,
    loList: false,
    addMasterLoDetails: false,
    industryList: false,
    jobRoleList: false,
    classRoomList: false,
    regionList: false,
    locationList: false,
    manageMentoring: false,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: false,
    viewLoadFactorPeople: false,
    scheduleCourse: false,
    checkAvailability: false,
    scheduledCourseList: false,
    addParticipantToSchedule: true,
    globalSettings: false,
    learnerScheduleList: false,
    courseCatlogList: true,
    nominationRequestList: true,
    addExternalUser: false,
    assetManagement: false,
    learningPlans: false,
    reports: true,
    nominationStatusList: false,
    manageSurveys: false,
    pendingForApproval: false,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: true,
  },
  training_manager: {
    dashboard: true,
    userManagement: true,
    userDetails: true,
    createRequest: true,
    createCourse: true,
    requestList: true,
    courseList: true,
    requestDetails: true,
    courseDetails: true,
    loDetails: true,
    competencyDetails: true,
    lessonPlanDetails: true,
    additionInfoDetails: true,
    courseAssessmentDetails: true,
    questionBankPreview: true,
    courseMaterialsDetails: true,
    trainerBondDetails: true,
    webinarCompetencyDetails: true,
    addLoDetails: false,
    addCompetencyDetails: false,
    addWebinarDetails: false,
    addLessonPlanDetails: false,
    addAdditionInfoDetails: false,
    addAssessmentDetails: false,
    addMaterialsDetails: false,
    curriculumList: true,
    policyList: true,
    addCurriculumDetails: true,
    questionBankList: true,
    createQuestionBankDetails: true,
    addPolicyDetails: true,
    sgaList: true,
    mapSGADetails: true,
    myLearningPlan: false,
    addAssessmentCatlog: true,
    assessmentCatlogDetails: true,
    scheduleAssessmentCatlog: true,
    scheduledUserDetails: true,
    competencyAssessment: true,
    reviewCompetencyAssessment: true,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: true,
    learnerAssessmetsList: false,
    learnerAssessmetsDetails: false,
    attemptsDetails: false,
    assessmentCatlogList: true,
    scheduledAssessmentsList: true,
    domainList: true,
    competencyList: true,
    loList: true,
    addMasterLoDetails: true,
    industryList: true,
    jobRoleList: true,
    classRoomList: true,
    regionList: true,
    locationList: true,
    manageMentoring: true,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: true,
    viewLoadFactorPeople: true,
    scheduleCourse: true,
    checkAvailability: true,
    scheduledCourseList: true,
    addParticipantToSchedule: true,
    globalSettings: true,
    learnerScheduleList: false,
    courseCatlogList: true,
    nominationRequestList: false,
    addExternalUser: true,
    assetManagement: true,
    learningPlans: true,
    reports: true,
    nominationStatusList: true,
    manageSurveys: true,
    pendingForApproval: true,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: false,
  },
  training_admin: {
    dashboard: true,
    userManagement: true,
    userDetails: true,
    createRequest: false,
    createCourse: false,
    requestList: false,
    courseList: true,
    requestDetails: false,
    courseDetails: true,
    loDetails: true,
    competencyDetails: true,
    lessonPlanDetails: true,
    additionInfoDetails: true,
    courseAssessmentDetails: true,
    questionBankPreview: true,
    courseMaterialsDetails: true,
    trainerBondDetails: false,
    webinarCompetencyDetails: true,
    addLoDetails: false,
    addCompetencyDetails: false,
    addWebinarDetails: false,
    addLessonPlanDetails: false,
    addAdditionInfoDetails: false,
    addAssessmentDetails: false,
    addMaterialsDetails: false,
    curriculumList: true,
    policyList: true,
    addCurriculumDetails: true,
    questionBankList: false,
    createQuestionBankDetails: false,
    addPolicyDetails: true,
    sgaList: true,
    mapSGADetails: false,
    myLearningPlan: false,
    addAssessmentCatlog: false,
    assessmentCatlogDetails: false,
    scheduleAssessmentCatlog: false,
    scheduledUserDetails: false,
    competencyAssessment: true,
    reviewCompetencyAssessment: false,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: false,
    learnerAssessmetsList: false,
    learnerAssessmetsDetails: false,
    attemptsDetails: false,
    assessmentCatlogList: false,
    scheduledAssessmentsList: false,
    domainList: true,
    competencyList: true,
    loList: true,
    addMasterLoDetails: true,
    industryList: true,
    jobRoleList: true,
    classRoomList: true,
    regionList: true,
    locationList: true,
    manageMentoring: true,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: true,
    viewLoadFactorPeople: true,
    scheduleCourse: true,
    checkAvailability: true,
    scheduledCourseList: true,
    addParticipantToSchedule: true,
    globalSettings: false,
    learnerScheduleList: false,
    courseCatlogList: true,
    nominationRequestList: false,
    addExternalUser: true,
    assetManagement: true,
    learningPlans: true,
    reports: true,
    nominationStatusList: true,
    manageSurveys: true,
    pendingForApproval: false,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: false,
  },
  hr_admin: {
    dashboard: true,
    userManagement: false,
    userDetails: false,
    createRequest: true,
    createCourse: true,
    requestList: true,
    courseList: true,
    requestDetails: true,
    courseDetails: true,
    loDetails: true,
    competencyDetails: true,
    lessonPlanDetails: true,
    additionInfoDetails: true,
    courseAssessmentDetails: true,
    questionBankPreview: true,
    courseMaterialsDetails: true,
    trainerBondDetails: false,
    webinarCompetencyDetails: true,
    addLoDetails: false,
    addCompetencyDetails: false,
    addWebinarDetails: false,
    addLessonPlanDetails: false,
    addAdditionInfoDetails: false,
    addAssessmentDetails: false,
    addMaterialsDetails: false,
    curriculumList: false,
    policyList: false,
    addCurriculumDetails: true,
    questionBankList: true,
    createQuestionBankDetails: true,
    addPolicyDetails: false,
    sgaList: true,
    mapSGADetails: true,
    myLearningPlan: false,
    addAssessmentCatlog: false,
    assessmentCatlogDetails: false,
    scheduleAssessmentCatlog: false,
    scheduledUserDetails: false,
    competencyAssessment: true,
    reviewCompetencyAssessment: false,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: false,
    learnerAssessmetsList: false,
    learnerAssessmetsDetails: false,
    attemptsDetails: false,
    assessmentCatlogList: false,
    scheduledAssessmentsList: false,
    domainList: true,
    competencyList: true,
    loList: true,
    addMasterLoDetails: true,
    industryList: true,
    jobRoleList: true,
    classRoomList: true,
    regionList: true,
    locationList: true,
    manageMentoring: true,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: false,
    viewLoadFactorPeople: false,
    scheduleCourse: true,
    checkAvailability: true,
    scheduledCourseList: true,
    addParticipantToSchedule: true,
    globalSettings: false,
    learnerScheduleList: false,
    courseCatlogList: true,
    nominationRequestList: false,
    addExternalUser: false,
    assetManagement: true,
    learningPlans: true,
    reports: true,
    nominationStatusList: true,
    manageSurveys: true,
    pendingForApproval: false,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: false,
  },
  sme: {
    dashboard: true,
    userManagement: false,
    userDetails: false,
    createRequest: false,
    createCourse: false,
    requestList: false,
    courseList: true,
    requestDetails: false,
    courseDetails: true,
    loDetails: true,
    competencyDetails: true,
    lessonPlanDetails: true,
    additionInfoDetails: true,
    courseAssessmentDetails: true,
    questionBankPreview: true,
    courseMaterialsDetails: true,
    trainerBondDetails: false,
    webinarCompetencyDetails: true,
    addLoDetails: false,
    addCompetencyDetails: false,
    addWebinarDetails: false,
    addLessonPlanDetails: false,
    addAdditionInfoDetails: false,
    addAssessmentDetails: false,
    addMaterialsDetails: false,
    curriculumList: false,
    policyList: false,
    addCurriculumDetails: false,
    questionBankList: false,
    createQuestionBankDetails: false,
    addPolicyDetails: false,
    sgaList: false,
    mapSGADetails: false,
    myLearningPlan: false,
    addAssessmentCatlog: false,
    assessmentCatlogDetails: false,
    scheduleAssessmentCatlog: false,
    scheduledUserDetails: false,
    competencyAssessment: true,
    reviewCompetencyAssessment: false,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: false,
    learnerAssessmetsList: false,
    learnerAssessmetsDetails: false,
    attemptsDetails: false,
    assessmentCatlogList: false,
    scheduledAssessmentsList: false,
    domainList: false,
    competencyList: false,
    loList: false,
    addMasterLoDetails: false,
    industryList: false,
    jobRoleList: false,
    classRoomList: false,
    regionList: false,
    locationList: false,
    manageMentoring: false,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: false,
    viewLoadFactorPeople: false,
    scheduleCourse: false,
    checkAvailability: false,
    scheduledCourseList: false,
    addParticipantToSchedule: false,
    globalSettings: false,
    learnerScheduleList: false,
    courseCatlogList: true,
    nominationRequestList: false,
    addExternalUser: false,
    assetManagement: false,
    learningPlans: false,
    reports: true,
    nominationStatusList: false,
    manageSurveys: false,
    pendingForApproval: false,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: false,
  },
  internal_trainer: {
    dashboard: true,
    userManagement: true,
    userDetails: true,
    createRequest: true,
    createCourse: false,
    requestList: true,
    courseList: true,
    requestDetails: true,
    courseDetails: true,
    loDetails: true,
    competencyDetails: true,
    lessonPlanDetails: true,
    additionInfoDetails: true,
    courseAssessmentDetails: true,
    questionBankPreview: true,
    courseMaterialsDetails: true,
    trainerBondDetails: false,
    webinarCompetencyDetails: true,
    addLoDetails: true,
    addCompetencyDetails: true,
    addWebinarDetails: true,
    addLessonPlanDetails: true,
    addAdditionInfoDetails: true,
    addAssessmentDetails: true,
    addMaterialsDetails: true,
    curriculumList: false,
    policyList: false,
    addCurriculumDetails: false,
    questionBankList: true,
    createQuestionBankDetails: true,
    addPolicyDetails: false,
    sgaList: false,
    mapSGADetails: false,
    myLearningPlan: false,
    addAssessmentCatlog: true,
    assessmentCatlogDetails: true,
    scheduleAssessmentCatlog: true,
    scheduledUserDetails: true,
    competencyAssessment: true,
    reviewCompetencyAssessment: true,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: true,
    learnerAssessmetsList: false,
    learnerAssessmetsDetails: false,
    attemptsDetails: false,
    assessmentCatlogList: true,
    scheduledAssessmentsList: true,
    domainList: true,
    competencyList: true,
    loList: true,
    addMasterLoDetails: true,
    industryList: false,
    jobRoleList: false,
    classRoomList: false,
    regionList: false,
    locationList: false,
    manageMentoring: false,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: true,
    viewLoadFactorPeople: false,
    scheduleCourse: false,
    checkAvailability: false,
    scheduledCourseList: true,
    addParticipantToSchedule: true,
    globalSettings: false,
    learnerScheduleList: false,
    courseCatlogList: true,
    nominationRequestList: false,
    addExternalUser: false,
    assetManagement: false,
    learningPlans: false,
    reports: true,
    nominationStatusList: true,
    manageSurveys: false,
    pendingForApproval: false,
    instructorActivityTimeTracking: true,
    upsertActivityTracking: true,
    trainingImpressions: false,
  },
  external_trainer: {
    dashboard: true,
    userManagement: false,
    userDetails: false,
    createRequest: false,
    createCourse: false,
    requestList: false,
    courseList: true,
    requestDetails: false,
    courseDetails: true,
    loDetails: true,
    competencyDetails: true,
    lessonPlanDetails: true,
    additionInfoDetails: true,
    courseAssessmentDetails: true,
    questionBankPreview: true,
    courseMaterialsDetails: true,
    trainerBondDetails: false,
    webinarCompetencyDetails: true,
    addLoDetails: true,
    addCompetencyDetails: true,
    addWebinarDetails: true,
    addLessonPlanDetails: true,
    addAdditionInfoDetails: true,
    addAssessmentDetails: true,
    addMaterialsDetails: true,
    curriculumList: false,
    policyList: false,
    addCurriculumDetails: false,
    questionBankList: true,
    createQuestionBankDetails: true,
    addPolicyDetails: false,
    sgaList: false,
    mapSGADetails: false,
    myLearningPlan: false,
    addAssessmentCatlog: true,
    assessmentCatlogDetails: true,
    scheduleAssessmentCatlog: true,
    scheduledUserDetails: true,
    competencyAssessment: true,
    reviewCompetencyAssessment: true,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: true,
    learnerAssessmetsList: false,
    learnerAssessmetsDetails: false,
    attemptsDetails: false,
    assessmentCatlogList: true,
    scheduledAssessmentsList: true,
    domainList: false,
    competencyList: false,
    loList: false,
    addMasterLoDetails: false,
    industryList: false,
    jobRoleList: false,
    classRoomList: false,
    regionList: false,
    locationList: false,
    manageMentoring: false,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: false,
    viewLoadFactorPeople: false,
    scheduleCourse: false,
    checkAvailability: false,
    scheduledCourseList: true,
    addParticipantToSchedule: true,
    globalSettings: false,
    learnerScheduleList: false,
    courseCatlogList: false,
    nominationRequestList: false,
    addExternalUser: false,
    assetManagement: false,
    learningPlans: false,
    reports: true,
    nominationStatusList: false,
    manageSurveys: false,
    pendingForApproval: false,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: false,
  },
  internal_learner: {
    dashboard: true,
    userManagement: false,
    userDetails: false,
    createRequest: false,
    createCourse: false,
    requestList: false,
    courseList: false,
    requestDetails: false,
    courseDetails: false,
    loDetails: false,
    competencyDetails: false,
    lessonPlanDetails: false,
    additionInfoDetails: false,
    courseAssessmentDetails: false,
    questionBankPreview: false,
    courseMaterialsDetails: false,
    trainerBondDetails: false,
    webinarCompetencyDetails: false,
    addLoDetails: false,
    addCompetencyDetails: false,
    addWebinarDetails: false,
    addLessonPlanDetails: false,
    addAdditionInfoDetails: false,
    addAssessmentDetails: false,
    addMaterialsDetails: false,
    curriculumList: false,
    policyList: false,
    addCurriculumDetails: false,
    questionBankList: false,
    createQuestionBankDetails: false,
    addPolicyDetails: false,
    sgaList: false,
    mapSGADetails: false,
    myLearningPlan: true,
    addAssessmentCatlog: false,
    assessmentCatlogDetails: false,
    scheduleAssessmentCatlog: false,
    scheduledUserDetails: false,
    competencyAssessment: true,
    reviewCompetencyAssessment: false,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: false,
    learnerAssessmetsList: true,
    learnerAssessmetsDetails: true,
    attemptsDetails: true,
    assessmentCatlogList: false,
    scheduledAssessmentsList: false,
    domainList: false,
    competencyList: false,
    loList: false,
    addMasterLoDetails: false,
    industryList: false,
    jobRoleList: false,
    classRoomList: false,
    regionList: false,
    locationList: false,
    manageMentoring: false,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: false,
    viewLoadFactorPeople: false,
    scheduleCourse: false,
    checkAvailability: false,
    scheduledCourseList: false,
    addParticipantToSchedule: false,
    globalSettings: false,
    learnerScheduleList: true,
    courseCatlogList: true,
    nominationRequestList: false,
    addExternalUser: false,
    assetManagement: false,
    learningPlans: false,
    reports: false,
    nominationStatusList: false,
    manageSurveys: false,
    pendingForApproval: false,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: false,
  },
  external_learner: {
    dashboard: true,
    userManagement: false,
    userDetails: false,
    createRequest: false,
    createCourse: false,
    requestList: false,
    courseList: false,
    requestDetails: false,
    courseDetails: false,
    loDetails: false,
    competencyDetails: false,
    lessonPlanDetails: false,
    additionInfoDetails: false,
    courseAssessmentDetails: false,
    questionBankPreview: false,
    courseMaterialsDetails: false,
    trainerBondDetails: false,
    webinarCompetencyDetails: false,
    addLoDetails: false,
    addCompetencyDetails: false,
    addWebinarDetails: false,
    addLessonPlanDetails: false,
    addAdditionInfoDetails: false,
    addAssessmentDetails: false,
    addMaterialsDetails: false,
    curriculumList: false,
    policyList: false,
    addCurriculumDetails: false,
    questionBankList: false,
    createQuestionBankDetails: false,
    addPolicyDetails: false,
    sgaList: false,
    mapSGADetails: false,
    myLearningPlan: true,
    addAssessmentCatlog: false,
    assessmentCatlogDetails: false,
    scheduleAssessmentCatlog: false,
    scheduledUserDetails: false,
    competencyAssessment: true,
    reviewCompetencyAssessment: false,
    competencyAssessmentDetails: true,
    reviewStandaloneAssessment: false,
    learnerAssessmetsList: true,
    learnerAssessmetsDetails: true,
    attemptsDetails: true,
    assessmentCatlogList: false,
    scheduledAssessmentsList: false,
    domainList: false,
    competencyList: false,
    loList: false,
    addMasterLoDetails: false,
    industryList: false,
    jobRoleList: false,
    classRoomList: false,
    regionList: false,
    locationList: false,
    manageMentoring: false,
    iamMentor: true,
    iamMentee: true,
    loadFactorList: false,
    viewLoadFactorPeople: false,
    scheduleCourse: false,
    checkAvailability: false,
    scheduledCourseList: false,
    addParticipantToSchedule: false,
    globalSettings: false,
    learnerScheduleList: true,
    courseCatlogList: false,
    nominationRequestList: false,
    addExternalUser: false,
    assetManagement: false,
    learningPlans: false,
    reports: false,
    nominationStatusList: false,
    manageSurveys: false,
    pendingForApproval: false,
    instructorActivityTimeTracking: false,
    upsertActivityTracking: false,
    trainingImpressions: false,
  },
};
